/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
import React from 'react';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  Icon,
  IconButton,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import { UserMinus, UserPlus } from 'phosphor-react';
import { FormHeading } from '../../../formHeading';
import AlertModal from '../../../AlertModal';
import { InputForm } from '../InputForm';
import { MaskedInputForm } from '../MaskedInputForm';
import { SelectInputForm } from '../SelectInputForm';

export const CustomParentsInputForm = ({
  name,
  label,
  optionsKinship,
  setFormValue,
  register,
  control,
  watch,
  errors,
}: any) => {
  const handleAddParent = () => {
    setFormValue(name, [
      ...watch(name),
      {
        name: '',
        email: '',
        cell_phone: '',
        kinship: null,
      },
    ]);
  };

  const deleteParent = index => {
    const parentsFiltered = watch(name)?.filter((_, idx) => {
      if (index === idx) {
        return false;
      }
      return true;
    });
    setFormValue(name, [...parentsFiltered]);
  };
  const { isOpen, onClose } = useDisclosure();

  const ButtonOpen = props => {
    return (
      <IconButton
        variant="solid"
        bg="#e6541c"
        _hover={{ opacity: 0.6 }}
        aria-label="delete"
        icon={<UserMinus color="white" />}
        {...props}
      />
    );
  };

  return (
    <FormControl isRequired isInvalid={!!errors[name]} mb={5}>
      <FormHeading mb={1}>{label}</FormHeading>

      <Stack spacing="10px" pt="10px" mb={5} direction="column" wrap="wrap">
        {watch(name)?.map((_, idx) => (
          <Flex
            key={idx as number}
            flex={1}
            gap={5}
            align="center"
            p="10px"
            border="1px solid rgba(0, 0, 0, 0.23)"
            borderRadius="6px"
          >
            <Box flex={1}>
              <InputForm
                name={`${name}.${idx}.name`}
                label="Nome"
                placeholder="Nome do responsável"
                isRequired
                register={register}
                errors={errors}
              />
            </Box>

            <Box flex={1}>
              <InputForm
                name={`${name}.${idx}.email`}
                label="Email"
                placeholder="Email do responsável"
                isRequired
                register={register}
                errors={errors}
              />
            </Box>

            <Box flex={1}>
              <MaskedInputForm
                name={`${name}.${idx}.cell_phone`}
                label="Telefone"
                placeholder="Telefone do responsável"
                isRequired
                control={control}
                errors={errors}
                mask="(99) 99999-9999"
              />
            </Box>

            <Box flex={1}>
              <SelectInputForm
                name={`${name}.${idx}.kinship`}
                label="Parentesco"
                options={optionsKinship}
                placeholder="Selecione o parentesco"
                isRequired
                control={control}
                errors={errors}
              />
            </Box>

            <AlertModal
              isOpenSecondary={isOpen}
              onCloseSecondary={onClose}
              msgStatus="warning"
              ButtonOpen={ButtonOpen}
              ConfirmButton={
                <Button
                  w="200px"
                  boxShadow="0px 2px 4px #00000050"
                  onClick={() => {
                    onClose();
                    deleteParent(idx);
                  }}
                >
                  Confirmar exclusão
                </Button>
              }
            />
          </Flex>
        ))}
      </Stack>

      <Flex direction="column" justify="center" align="center" gap={5}>
        {watch(name)?.length === 0 && (
          <Text>
            Nenhum responsável atribuído no momento.{' '}
            <strong>Para atribuir um responsável clique no botão abaixo</strong>
          </Text>
        )}

        <Flex
          w="300px"
          h="40px"
          p="5px"
          mt="5px"
          bg={useColorModeValue('theme.light.bodyInput', 'theme.dark.bodyInput')}
          cursor="pointer"
          transition="0.2s ease"
          align="center"
          justify="space-between"
          borderRadius="5px"
          _hover={{ opacity: 0.6 }}
          textTransform="uppercase"
          boxShadow="0px 2px 4px #00000050"
          onClick={handleAddParent}
        >
          <div />
          <Icon as={UserPlus} mr="5px" fontSize="25px" />
          <Text fontWeight="bold">Adicionar responsável</Text>
          <div />
        </Flex>

        {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
      </Flex>
    </FormControl>
  );
};
